import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.benutzer-zum-dienst-einteilen-multi';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenBenutzerZumDienstEinteilenMultiEffects {

    BenutzerZumDienstEinteilenMulti$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BENUTZER_ZUM_DIENST_EINTEILEN_MULTI),
        mergeMap((x: ac.PostBenutzerZumDienstEinteilenMultiAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBenutzerZumDienstEinteilenMulti(x.benutzerZumDienstEinteilenMultiRequest).pipe(
                map((result: any) => {
                    return new ac.PostBenutzerZumDienstEinteilenMultiErfolgreichAction(result, x.benutzerZumDienstEinteilenMultiRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBenutzerZumDienstEinteilenMultiFehlerAction(error, x.benutzerZumDienstEinteilenMultiRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.RollenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.RollenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.RollenCommandService);
        }
        return this.service;
    }
}
